// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dx-row td {\n  border-bottom: 1px solid #ddd !important;\n}", "",{"version":3,"sources":["webpack://src/components/utility-component/expression-builder/expression-builder.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;AACF","sourcesContent":[".dx-row td {\n  border-bottom: 1px solid #ddd!important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
